/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Office */


Office.onReady(() => {
  // If needed, Office.js is ready to be called.
});

/**
 * Shows a notification when the add-in command is executed.
 * @param event {Office.AddinCommands.Event}
 */

function action(event) {
  fetch('https://api.signatyr.com/api/user?email=' + Office.context.mailbox.userProfile.emailAddress,
    {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    }
  ).then((response) => {
    return response.json();
  })
    .then((data) => {
      // Show a notification message.
      Office.context.mailbox.item.body.setSignatureAsync(data.signature.content,
        { coercionType: "html" },
        function (asyncResult) {
          console.log(`setSignatureAsync: ${asyncResult.status}`);
        }
      );

      // Be sure to indicate when the add-in command function is complete.
      event.completed();
    });
}

// Register the function with Office.
Office.actions.associate("action", action);